import { Paper, Typography, Link } from "@mui/material";

const CampaignDescription = ({ campaignDescription }) => {
  const urlRegex =
    /(https?:\/\/[^\s]+|www\.[^\s]+|\b[a-z0-9.-]+\.[a-z]{2,}\b)/gi;

  const parts = campaignDescription?.split(urlRegex);
  return (
    <Paper
      sx={{
        p: 3,
        mb: 3,
        mt: 4,
        boxShadow: "rgba(149, 157, 165, 0.2) 0px 8px 24px",
      }}
    >
      <Typography variant="h6" sx={{ mb: 2, fontWeight: "600" }}>
        Campaign Description
      </Typography>
      <Typography variant="body1" sx={{ whiteSpace: "pre-line" }}>
        {parts?.map((part, index) =>
          urlRegex?.test(part) ? (
            <Link
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ fontWeight: 500 }}
            >
              {part}
            </Link>
          ) : (
            part
          )
        )}
      </Typography>
    </Paper>
  );
};

export default CampaignDescription;
